import removeUserIcon from '../../assets/remove-user.svg';
import { PermittedUser } from '../../types';
import styles from './AssignedUsersCard.module.scss';

type AssignedUserRowProps = {
  user: PermittedUser;
  disabled: boolean;
  onRemove: (user: PermittedUser) => void;
};

export const AssignedUserRow = ({ user, disabled, onRemove }: AssignedUserRowProps) => (
  <article className={styles.row}>
    <div className={styles.identity}>
      <strong>{user.user_name}</strong>
      <span>{user.user_email}</span>
    </div>

    <button type="button" className={styles.removeButton} disabled={disabled} onClick={() => onRemove(user)}>
      <img src={removeUserIcon} alt="" aria-hidden="true" />
      Remover
    </button>
  </article>
);
